var YouTubePlayer = (function() {
    /**
     * YouTube Player Api wrap
     * @param {DOM Object} element video holder element
     * @param {object} settings
     *
     */
    var defaultPlayerOptions = {
        videoId: 'ScMzIvxBSi4',
        width: 640,
        height: 390,
        playerVars: {
            autoplay: 0,
            controls: 1
        }
    };

    function YouTubePlayer(element, settings) {
        this.element = element;

        this.settings = settings || {};

        this.playerOptions =
            this.extractYTOptions() ||
            this.settings.playerOptions ||
            defaultPlayerOptions;

        this.player = null;

        this.pane = null;

        this.onReady = function() {};

        this.init();
    }

    YouTubePlayer.prototype.init = function() {
        var that = this;

        this.addEvents();

        this.createPane();

        if (!('YT' in window)) {
            console.error(
                'Please include youtube iframe api (https://www.youtube.com/iframe_api).'
            );
            return;
        }

        if (YT.loaded) {
            this.initPlayer();
        } else {
            YT.ready(function() {
                that.initPlayer();
            });
        }

        // make reachable from the element
        this.element.player = this;

        if ('jQuery' in window) {
            jQuery(this.element).data('player', this);
        }
    };

    YouTubePlayer.prototype.createPane = function() {
        this.pane = document.createElement('div');

        this.pane.className = 'youtube-player-pane';

        this.element.appendChild(this.pane);
    };

    YouTubePlayer.prototype.addEvents = function() {
        var that = this;
        this.playerOptions.events = {
            // onReady                 : this.settings.onPlayerReady || function() {},
            onReady: function() {
                that.onReady();
            },
            onPlaybackQualityChange:
                this.settings.onPlayerPlaybackQualityChange || function() {},
            onStateChange: this.settings.onPlayerStateChange || function() {},
            onError: this.settings.onPlayerError || function() {}
        };
    };

    YouTubePlayer.prototype.initPlayer = function() {
        this.player = new YT.Player(this.pane, this.playerOptions);
    };

    YouTubePlayer.prototype.extractYTOptions = function() {
        var options = null;

        var elementData = this.element.dataset;

        if ('ytVideoId' in elementData) {
            options = {
                videoId: elementData.ytVideoId,
                width: elementData.ytWidth,
                height: elementData.ytHeight,
                playerVars: {
                    autoplay:
                        typeof elementData.ytAutoplay !== 'undefined'
                            ? elementData.ytAutoplay
                            : 0,
                    controls:
                        typeof elementData.ytControls !== 'undefined'
                            ? elementData.ytControls
                            : 1,
                    showinfo:
                        typeof elementData.ytInfo !== 'undefined'
                            ? elementData.ytInfo
                            : 1,
                    rel:
                        typeof elementData.ytAutoplay !== 'undefined'
                            ? elementData.ytAutoplay
                            : 0
                }
            };
        }

        return options;
    };

    YouTubePlayer.prototype.play = function() {
        var that = this;
        if (!this.player) {
            YT.ready(function() {
                that.onReady = function() {
                    that.play();
                };
            });
        } else {
            if ('playVideo' in this.player) {
                this.player.playVideo();
            }
        }
    };

    YouTubePlayer.prototype.pause = function() {
        if ('pauseVideo' in this.player) {
            this.player.pauseVideo();
        }
    };

    YouTubePlayer.prototype.stop = function() {
        if ('stopVideo' in this.player) {
            this.player.stopVideo();
        }
    };

    YouTubePlayer.prototype.destroy = function() {
        if ('destroy' in this.player) {
            this.player.destroy();
        }
    };

    YouTubePlayer.prototype.mute = function() {
        if ('mute' in this.player) {
            this.player.mute();
        }
    };

    YouTubePlayer.prototype.unmute = function() {
        if ('unMute' in this.player) {
            this.player.unMute();
        }
    };

    return YouTubePlayer;
})();

export default YouTubePlayer;



// WEBPACK FOOTER //
// ./../src/assets/js/youtube-player.js